<template>
  <router-view :key="$route.params.sector_id" />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('sectors', ['getSector']),
    sector() {
      return this.getSector(this.$route.params.sector_id);
    },
  },
  watch: {
    sector: {
      handler(newValue) {
        const isLocalBrandsPage = this.$route.matched.some(({ name }) => name === 'local-brands');
        if (!newValue || !newValue.id) return;
        this.$store.commit('adminPanel/setViewTitle', {
          depth: 1,
          title: newValue.name,
          last: !isLocalBrandsPage,
          to: { name: 'menu-sector-info', params: { sector_id: newValue.id } },
        });
      },
      immediate: true,
    },
  },
  async mounted() {
    const { sector_id } = this.$route.params;
    if (!sector_id) return;
    try {
      this.$store.commit('adminPanel/setLoading', true);
      this.$store
        .dispatch('sectors/fetchSector', {
          sector_id: this.$route.params.sector_id,
          expanded: false,
        })
        .then((active_sector) => {
          this.$store.commit('sectors/setActiveSector', active_sector);
        });

      this.$store.commit('adminPanel/setLoading', false);
    } catch (err) {
      console.error(err);
      this.$toast.error('Error fetching sector');
    }
  },
};
</script>

<style>
.v-chip.fit-content,
.v-chip.fit-content .v-chip__content {
  height: fit-content !important;
}
</style>
